import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

/** Mobile card row that replaces a table row under 640px.
 *
 * Props:
 *   to          — link target (used by react-router navigate)
 *   title       — primary text (e.g. invoice number, client name)
 *   subtitle    — secondary text under the title
 *   amount      — right-aligned money string
 *   meta        — array of {label, value} small chips below the title row
 *   right       — element rendered to the right of the title (e.g. <StatusBadge/>)
 *   testId      — data-testid for the card root
 */
export default function MobileListCard({
    to,
    title,
    subtitle,
    amount,
    meta = [],
    right,
    testId,
}) {
    const navigate = useNavigate();
    return (
        <button
            type="button"
            onClick={() => to && navigate(to)}
            className="w-full text-left brand-card mb-2 fade-up flex flex-col gap-2"
            style={{
                background: "var(--brand-white, #fff)",
                cursor: to ? "pointer" : "default",
            }}
            data-testid={testId}
        >
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                    <p
                        className="font-display font-bold leading-tight truncate"
                        style={{ fontSize: "1rem" }}
                    >
                        {title}
                    </p>
                    {subtitle && (
                        <p className="text-xs text-muted truncate mt-0.5">{subtitle}</p>
                    )}
                </div>
                <div className="flex flex-col items-end shrink-0 gap-1">
                    {right}
                    {amount !== undefined && amount !== null && (
                        <p
                            className="font-mono font-bold text-sm"
                            style={{ color: "var(--brand-dark)" }}
                        >
                            {amount}
                        </p>
                    )}
                </div>
            </div>
            {meta.length > 0 && (
                <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-muted">
                    {meta.filter((m) => m.value).map((m, i) => (
                        <span key={i}>
                            <span className="opacity-70">{m.label}:</span>{" "}
                            <span className="text-foreground">{m.value}</span>
                        </span>
                    ))}
                </div>
            )}
            {to && (
                <div
                    className="flex items-center gap-1 text-xs"
                    style={{ color: "var(--brand-red)" }}
                >
                    <span>Open</span>
                    <ChevronRight size={12} />
                </div>
            )}
        </button>
    );
}
